<app-repair-line-items-table
  [filter]="filter"
  [columns]="repairLineItemTableColumns"
  [maintainceOrderStatus]="maintainceOrderStatus"
  [maintenanceOrderSourceApplication]="maintenanceOrderSourceApplication"
  [workOrderMode]="workOrderMode"
  (sortChange)="onSortChange($event)"></app-repair-line-items-table>
<h1></h1>
